<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="사업장(공사) 관리" device="web" :IsUseSearchRequirement="true">
        <template v-slot:SearchRequirement>
          <v-row no-gutters>
            <v-col class="d-flex justify-space-between align-center">
              <v-switch v-model="companyUseYn">
                <template v-slot:label>
                  <span style="margin-left: 5px">{{ companyUseYn ? '사용' : '미사용' }}</span>
                </template>
              </v-switch>
            </v-col>
          </v-row>
        </template>

        <template v-slot:body>
          <DxDataGrid
            id="companyDataGrid"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :selection="{ mode: 'single' }"
            key-expr="uniqueKey"
            :focused-row-enabled="true"
            @row-updating="onRowUpdating"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

            <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />

            <DxColumn data-field="clntId" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="compId" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="writeDt" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="docNo" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="paymentType" data-type="string" :visible="false"></DxColumn>

            <DxColumn
              data-field="save"
              data-type="string"
              width="100px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <div>
                <v-btn color="primary" elevation="0" dark small @click="btnDetail(cellInfo)" class="rounded px-3 grid-btn">상세보기</v-btn>
              </div>
            </template>
            <DxColumn
              data-field="approvalStatus"
              data-type="string"
              width="120px"
              alignment="center"
              caption="공사 승인"
              cell-template="approvalStatusTemplate"
              :allow-editing="false"
            />
            <template #approvalStatusTemplate="{ data: cellInfo }">
              <div :style="getStatusStyle('approvalList', cellInfo.data.approvalStatus)">
                {{ getStatusNm('approvalList', cellInfo.data.approvalStatus) }}
              </div>
            </template>
            <DxColumn
              data-field="paymentStatus"
              data-type="string"
              alignment="center"
              caption="결제 승인"
              width="200px"
              cell-template="paymentApprovalTemplate"
              :allow-editing="false"
            />
            <template #paymentApprovalTemplate="{ data: cellInfo }">
              <div class="d-flex justify-start">
                <div :style="getStatusStyle('paymentList', cellInfo.data.paymentStatus)">
                  {{ getStatusNm('paymentList', cellInfo.data.paymentStatus) }}
                </div>
                <div
                  v-if="cellInfo.data.orderType && (cellInfo.data.paymentStatus === 'N' || cellInfo.data.paymentStatus === 'A')"
                  style="color: #b4b4b4"
                >
                  {{ `/${cellInfo.data.orderType === 'AC' ? '직접계좌이체' : '카드(신용)'}` }}
                  {{ `${cellInfo.data.paymentType === 'BILLING' ? (cellInfo.data.activeFeeType === 'monthly' ? '/ 정액제' : '/ 월 구독') : ''}` }}
                </div>
              </div>
            </template>
            <DxColumn
              data-field="cancelStatus"
              data-type="string"
              alignment="center"
              caption="해지 승인"
              width="130px"
              :allow-editing="false"
              cell-template="cancelApprovalTemplate"
            />
            <template #cancelApprovalTemplate="{ data: cellInfo }">
              <div :style="getStatusStyle('cancelList', cellInfo.data.cancelStatus)">{{ getStatusNm('cancelList', cellInfo.data.cancelStatus) }}</div>
            </template>
            <DxColumn data-field="compNm" data-type="string" width="200px" alignment="left" caption="사업장(공사)명" :allow-editing="false" />

            <DxColumn data-field="rpstNm" data-type="string" width="100px" alignment="center" caption="대표자명" :allow-editing="false" />

            <DxColumn data-field="constructNm" data-type="string" width="150px" alignment="left" caption="공사 분류" :allow-editing="false" />

            <DxColumn data-field="constructTerm" caption="사용 기간" width="250px" data-type="string" alignment="center" :allow-editing="false" />

            <DxColumn data-field="constructAmount" data-type="string" alignment="right" caption="공사비용" width="150px" :allow-editing="false" />

            <DxColumn data-field="addrs" data-type="string" alignment="left" caption="주소" :allow-editing="false" />

            <DxColumn data-field="useYn" data-type="boolean" width="90px" caption="사용" alignment="center" edit-cell-template="checkBoxEditor" />

            <DxColumn data-field="compOrderBy" data-type="int" width="90px" caption="정렬" alignment="center" />

            <template #checkBoxEditor="{ data: cellInfo }">
              <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)" />
            </template>
          </DxDataGrid>
        </template>
      </i-card-vertical>
      <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnAdd="btnAdd()" @btnSave="btnSave()"></i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import { getCompManage, saveCompManage } from '@/api/sojunganManagement/compMange'
import { getConstructManage } from '@/api/sojunganManagement/constructManage'
import { getCommonCode } from '@/api/common/commonApi'
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'compManage',
  components: {
    'i-card-vertical': iCardVertical,
  },
  data() {
    return {
      dxDataGridRef: 'companyDataGrid',
      companyUseYn: true,
      gridMain: [],
      valid: true,
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', // 저장
      ],
      allMode: 'allPages',
      approvalList: [],
      paymentList: [],
      cancelList: [],
    }
  },
  watch: {
    companyUseYn() {
      this.btnSearch(true)
    },
  },
  computed: {},
  beforeMount() {},
  created() {
    // 승인 / 결제 / 해지 단계 공통코드 조회
    Promise.all([getCommonCode('CM014'), getCommonCode('CM017'), getCommonCode('CM018')]).then((res) => {
      ;(this.approvalList = res[0].list), (this.paymentList = res[1].list), (this.cancelList = res[2].list)
    })
  },
  activated() {
    if (this.$route.params.data?.monthlyPaymentAlert) {
      this.vToastify(this.$t('사업장(공사)추가 및 승인 후 일반 요금제로 결제하십시오.'), 'info')
    }
    // 메뉴 재진입 시에도 현재 사용/미사용 조건으로 목록 갱신
    this.btnSearch(true)
  },
  methods: {
    getStatusStyle(dataList, status) {
      // 진행상태에 따라 스타일 부여
      let style = 'color:#B4B4B4;'
      let statusCd = this[dataList].find((el) => el.minorCd === status)
      if (statusCd) {
        switch (statusCd.minorCd) {
          case 'N':
            style = `color:#B4B4B4;`
            break
          case 'R':
            style = `color:#FF2D2D;`
            break
          case 'S':
            style = `color:#CC6600;`
            break
          case 'A':
            style = `color:#1B53F3;`
            break
        }
      }
      return style
    },
    getStatusNm(dataList, status) {
      let statusCd = this[dataList].find((el) => el.minorCd === status)
      if (statusCd) return statusCd.minorNm
      else return '-'
    },
    //------------------------------------------
    //  사업장 조회
    //------------------------------------------
    async btnSearch(isNotify) {
      this.openLoading('searching')

      let params = {
        useYn: this.companyUseYn ? 'Y' : 'N',
        clntId: this.getClntId(),
      }

      let params2 = {
        clntId: this.getClntId(),
      }

      try {
        const response = await getCompManage(params, isNotify)
        const response2 = await getConstructManage(params2, isNotify)
        console.log(response2)
        const response2Map = {}
        response2.list.forEach((item) => {
          const key = `${item.clntId}${item.compId}`
          response2Map[key] = {
            writeDt: item.writeDt,
            docNo: item.docNo,
            constructTerm: `${item.constructDtS.slice(0, 4)}.${item.constructDtS.slice(4, 6)}.${item.constructDtS.slice(
              6,
              8
            )} ~ ${item.constructDtE.slice(0, 4)}.${item.constructDtE.slice(4, 6)}.${item.constructDtE.slice(6, 8)}`,
            constructAmount: item.constructAmount,
            approvalStatus: item.approvalStatus,
            paymentStatus: item.paymentStatus,
            cancelStatus: item.cancelStatus,
            orderType: item.orderType,
            paymentType: item.paymentType,
            activeFeeType: item.activeFeeType,
          }
        })
        if (response.success && response2.success) {
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.gridMain = []
          this.gridMain = response.list
          this.gridMain = response.list.map((item, index) => {
            let addressParts = []
            if (item.zipCd !== null) {
              addressParts.push(`(${item.zipCd})`)
            }
            if (item.addrs1 !== null) {
              addressParts.push(item.addrs1)
            }
            if (item.addrs2 !== null) {
              addressParts.push(item.addrs2)
            }
            item.addrs = addressParts.join(' ')
            item.uniqueKey = `${item.clntId}${item.compId}`
            // response2Map에서 해당 item의 clntId와 compId를 기준으로 데이터 찾기
            const response2Data = response2Map[item.uniqueKey]

            if (response2Data) {
              item.writeDt = response2Data.writeDt
              item.docNo = response2Data.docNo
              item.approvalStatus = response2Data.approvalStatus
              item.constructTerm = response2Data.constructTerm
              item.constructAmount = response2Data.constructAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원'
              item.paymentStatus = response2Data.paymentStatus
              item.cancelStatus = response2Data.cancelStatus
              item.orderType = response2Data.orderType
              item.paymentType = response2Data.paymentType
              item.activeFeeType = response2Data.activeFeeType
            } else {
              item.writeDt = null // 혹은 적절한 기본값 설정
              item.docNo = null // 혹은 적절한 기본값 설정
              item.constructTerm = null
              item.constructAmount = null
            }

            return item
          })
          this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
        }
      } catch (error) {
        console.error('getCompManage error catch >> ', error)
      } finally {
        this.endLoading()
      }
    },
    //------------------------------------------
    //  사업장 추가
    //------------------------------------------
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', { value: true })
      Object.defineProperty(data, 'clntId', { value: this.getClntId() })
      const toRouter = {
        name: 'CompManageDetail',
        params: {
          data: data,
        },
      }
      this.$router.push(toRouter)
    },
    //------------------------------------------
    //  사업장 저장
    //------------------------------------------
    btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then((selectedRows) => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }

          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            async () => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              for (const item of selectedRows) {
                const compOrderBy = parseInt(item.compOrderBy)
                if (isNaN(compOrderBy) || compOrderBy < 0) {
                  this.vToastify(this.$t('정렬은 숫자만 입력가능합니다.'), 'info')
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  return
                }
              }
              this.openLoading('saving')
              try {
                const response = await saveCompManage(selectedRows, true)
                if (response.success) {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.btnSearch(false)
                }
              } catch (error) {
                console.error('saveCompManage error catch >> ', error)
              } finally {
                this.endLoading()
              }
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  사업장 상세페이지 이동
    //------------------------------------------
    async btnDetail(cellInfo) {
      cellInfo.data.__created__ = false
      const toRouter = {
        name: 'CompManageDetail',
        params: {
          data: cellInfo.data,
        },
      }
      this.$router.push(toRouter)
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onEditingStart(e) {},
    onCheckValueChanged(value, cellInfo) {
      console.log(cellInfo.value)
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },
  },
}
</script>

<style scoped></style>
